/** Path of a mosaic alone in its window. */
export const mosaicWindowPath = (id: string) => `/mosaico/${encodeURIComponent(id)}`;

/**
 * Opens a mosaic in its own window, reused when the same mosaic is opened
 * again (it can live on another monitor). False when the browser blocked it.
 */
export function openMosaicWindow(id: string): boolean {
  const w = window.open(
    mosaicWindowPath(id),
    `proguard-mosaico-${id}`,
    'popup=yes,width=1280,height=760',
  );
  if (!w) return false;
  w.focus();
  return true;
}
